import useCatalogFilters from 'composables/useCatalogFilters';
import useFilters from 'composables/useFilters';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    facet: {
      type: Object,
      required: true,
    },
    isBoxCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const filterStore = props.isBoxCatalog ? useCatalogFilters() : useFilters();
    const { getCurrentFilters, getCardSelected } = filterStore;

    return {
      currentFilters: getCurrentFilters,
      cardSelected: getCardSelected,
      filterStore,
    };
  },
})
export default class FacetComponent extends Vue {
  openAcordion = false;
  isMobile = window.innerWidth <= 768;
  isProcessingCategoryName = false;

  mounted() {
    this.openAcordion = !this.isMobile;
    this.handleSingleCategoryAutoSelect();
  }

  acordion() {
    this.openAcordion = !this.openAcordion;
  }

  async onChange(key, inputType) {
    try {
      // Obtener el valor actual del estado DESPUÉS del cambio del v-model
      await this.$nextTick();

      let currentValue = this.currentFilters[this.cardSelected][key];

      if (
        key === 'category_name' &&
        Array.isArray(currentValue) &&
        currentValue.length > 1
      ) {
        const lastSelected = currentValue[currentValue.length - 1];
        currentValue = [lastSelected];
        Vue.set(this.currentFilters[this.cardSelected], key, currentValue);
      }

      await this.filterStore.updateFilters({
        key,
        inputType,
        value: currentValue,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error updating filter:', error);
    }
  }

  /**
   * TODO: Revisar si podemos mover esto fuera del componente
   * Maneja la selección automática de categoría cuando solo hay una opción
   */
  handleSingleCategoryAutoSelect() {
    if (this.shouldAutoSelectCategory()) {
      this.isProcessingCategoryName = true;

      this.$nextTick(() => {
        setTimeout(async () => {
          try {
            const categoryValue = this.facet.results[0].value;
            //  It's special for categories bc it works as an array, but it came as radio from the backend
            Vue.set(this.currentFilters[this.cardSelected], 'category_name', [
              categoryValue,
            ]);
            await this.filterStore.updateFilters({
              key: 'category_name',
              inputType: this.facet.input_type,
              value: [categoryValue],
            });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error auto-selecting category:', error);
          } finally {
            this.isProcessingCategoryName = false;
          }
        }, 100);
      });
    }
  }

  /**
   * Determina si debe auto-seleccionar la categoría
   */
  shouldAutoSelectCategory() {
    return (
      this.facet.name === 'category_name' &&
      this.facet.results &&
      this.facet.results.length === 1 &&
      (!this.currentFilters[this.cardSelected][this.facet.name] ||
        this.currentFilters[this.cardSelected][this.facet.name].length === 0) &&
      !this.isProcessingCategoryName
    );
  }

  @Watch('currentFilters', { immediate: true, deep: true })
  onCurrentFilterChange() {
    if (!this.isProcessingCategoryName) {
      this.handleSingleCategoryAutoSelect();
    }
  }

  @Watch('facet.results', { immediate: true })
  onFacetResultsChange() {
    if (!this.isProcessingCategoryName) {
      this.handleSingleCategoryAutoSelect();
    }
  }
}